import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { UserInfo } from '@/services/user'

import { SubscribeButton } from './subscribeButton'

interface SubscribeUserContentProps {
  userInfo: UserInfo
  amount: number
}

export const SubscribeUserContent: FC<SubscribeUserContentProps> = ({
  userInfo,
  amount,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className="px-12">
      <div className="pb-8 pt-12 px-12">
        <span className="text-lg font-bold">
          {t('profile.subscription.subscribeTitle')}
        </span>
      </div>
      <SubscribeButton amount={amount} userInfo={userInfo} />
      <p className="text-[1rem] text-xs mt-3">
        <Trans i18nKey="profile.subscription.subscribeTip">
          {t('profile.subscription.subscribeTip')}
        </Trans>
      </p>
    </div>
  )
}
